var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore3002181({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6734 8.23227C15.8854 6.67287 11.4105 4.16885 4.4696 0.282486C4.00164 -0.0265614 3.46324 -0.0670615 2.99805 0.090392L14.9067 11.999L18.6734 8.23227Z",
    fill: "#32BBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99788 0.090332C2.91069 0.119863 2.82585 0.155488 2.7447 0.19852C2.231 0.476395 1.85352 1.0111 1.85352 1.68737V22.3105C1.85352 22.9868 2.23095 23.5215 2.7447 23.7993C2.82571 23.8423 2.9105 23.8781 2.9976 23.9078L14.9065 11.9989L2.99788 0.090332Z",
    fill: "#32BBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9069 11.999L2.99805 23.9079C3.46338 24.0665 4.00178 24.0291 4.46988 23.7155C11.201 19.9463 15.6255 17.472 18.4458 15.8993C18.5243 15.8552 18.6012 15.8121 18.6772 15.7694L14.9069 11.999Z",
    fill: "#32BBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.85352 11.999V22.3106C1.85352 22.9869 2.23095 23.5216 2.7447 23.7994C2.82571 23.8424 2.9105 23.8782 2.9976 23.9079L14.9065 11.999H1.85352Z",
    fill: "#2C9FD9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46886 0.282559C3.91316 -0.0843794 3.25784 -0.0739263 2.74414 0.198699L14.7252 12.1798L18.6726 8.23234C15.8846 6.67295 11.4098 4.16893 4.46886 0.282559Z",
    fill: "#29CC5E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7253 11.8184L2.74414 23.7994C3.25789 24.072 3.91316 24.0877 4.46886 23.7155C11.2 19.9463 15.6245 17.472 18.4448 15.8993C18.5233 15.8552 18.6002 15.8121 18.6762 15.7694L14.7253 11.8184Z",
    fill: "#D93F21"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6456 11.9989C23.6456 11.4275 23.3573 10.8509 22.7858 10.5311C22.7858 10.5311 21.7171 9.93479 18.4413 8.10254L14.5449 11.9989L18.4451 15.8992C21.6849 14.0801 22.7857 13.4667 22.7857 13.4667C23.3573 13.147 23.6456 12.5703 23.6456 11.9989Z",
    fill: "#FFD500"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 13.4669C23.3573 13.1471 23.6456 12.5704 23.6456 11.999H14.5449L18.4451 15.8993C21.685 14.0802 22.7858 13.4669 22.7858 13.4669Z",
    fill: "#FFAA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore3002181);
export default __webpack_public_path__ + "static/media/playstore_300218 1.fae9e3e28b89f2e6bc213f593754c4d8.svg";
export { ForwardRef as ReactComponent };